const DASHBOARD_SLOTS = {
  BOTTOM_LEFT: 'bottom_left',
  BOTTOM_MIDDLE: 'bottom_middle',
  BOTTOM_RIGHT: 'bottom_right',
  CENTER: 'center',
  LEFT_NAV: 'left_nav',
  NAVBAR: 'navbar',
  TOOLTIP: 'tooltip',
  TOP_LEFT: 'top_left',
  TOP_MIDDLE: 'top_middle',
  TOP_RIGHT: 'top_right',
};

const DESIGNER_SLOTS = {
  ANALYZE_PANEL: 'analyze_panel',
  APPS_PANEL: 'apps_panel',
  CANVAS: 'canvas',
  SETTINGS_PANEL_BACKUPS: 'settings_panel/backups',
  TOP_BAR: 'top_bar',
  TOP_RIGHT: 'top_right',
};

// Object that enumerates all possible locations on a page where an in-product notification can appear.
// Maintaining this enumeration will help create a common understanding of locations where IPNs are rendered.
// If you are unsure which slot to use, or if you want to update this enumeration, reach out to the Shared Services team.
export const IPN_SLOT = {
  ...DASHBOARD_SLOTS,
  ...DESIGNER_SLOTS,
  UNKNOWN: 'unknown', // To be used as temporary state when the actual slot is not known or is TBD.
} as const;

export type IpnSlot = (typeof IPN_SLOT)[keyof typeof IPN_SLOT];
